import { render, staticRenderFns } from "./SnackbarBase.vue?vue&type=template&id=68d47d2d&scoped=true&lang=pug"
import script from "./SnackbarBase.vue?vue&type=script&lang=js"
export * from "./SnackbarBase.vue?vue&type=script&lang=js"
import style0 from "./SnackbarBase.vue?vue&type=style&index=0&id=68d47d2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d47d2d",
  null
  
)

export default component.exports